import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div data-testid="payment-cancel-page" className="min-h-[80vh] flex items-center justify-center px-4 pt-24 pb-16">
      <div className="max-w-lg w-full rounded-3xl bg-white border border-slateblue/15 p-10 text-center">
        <h1 className="font-serif text-3xl text-navy">No charge was made</h1>
        <p className="mt-4 text-sm sm:text-base text-charcoal/75 leading-relaxed">
          You cancelled checkout before paying. The Planning Kit will be here whenever you're ready.
        </p>
        <Link
          to="/planning-kit"
          data-testid="cancel-back-button"
          className="mt-8 inline-flex items-center gap-2 rounded-full bg-navy px-8 py-3.5 text-sm font-semibold text-ivory transition-colors duration-300 hover:bg-ocean"
        >
          <ArrowLeft className="h-4 w-4" />
          Back to the kit
        </Link>
      </div>
    </div>
  );
}
